export default __webpack_public_path__ + "static/media/bird_log_meta_data.ba42f332.svg";